module.exports = __webpack_public_path__ + "static/media/au.bb307e7f.svg";